import { Alert, Box, LinearProgress } from "@mui/material";
import GenericSelectLayout, { SelectType } from "../../components/GenericSelectLayout";
import styles from "./SelectClient.module.css";
import { useClientAccessContext } from "../../context/ClientAccessContext";
import { useNavigate } from "react-router-dom";
import { routes } from "../../router/routes";
import { useEffect } from "react";

const SelectClient = () => {
  const { selectedClient, setSelectedClient, userWithClients, loadingClients } = useClientAccessContext();
  const navigate = useNavigate();

  useEffect(() => {
    if (selectedClient) {
      navigate(routes.overview);
    }
    if (userWithClients?.clientAccesses?.length === 1) {
      handleSelectClient(userWithClients.clientAccesses[0]);
    }
  }, [selectedClient, navigate]);

  const handleSelectClient = (client) => {
    setSelectedClient(client);
  };

  if (loadingClients) {
    return (
      <Box>
        <LinearProgress />
      </Box>
    );
  }

  return (
    <>
      {userWithClients?.clientAccesses?.length ? (
        <div className={styles.container}>
          <GenericSelectLayout
            type={SelectType.Client}
            items={userWithClients.clientAccesses}
            onCardClick={(item) => handleSelectClient(item)}
          />
        </div>
      ) : (
        <Alert severity="info">You do not have any topic access</Alert>
      )}
    </>
  );
};

export default SelectClient;
